module.exports = __webpack_public_path__ + "img/error.ef044c78.png";